import {
  ComponentPropsCollection,
  DictionaryPhrases,
  Field,
  ImageField,
  Item,
  LayoutServiceData,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { Session } from 'next-auth';
import { InstantSearchServerState } from 'react-instantsearch-hooks-web';

// This array should match the options within ValidHeadingLevels
export const ValidHeadingLevelOptions = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p'] as const;
/**
 * Ensure any heading level parameter used in a sitecore rendering is valid.
 * If an unvalid level is used, default to a valid heading level - h2.
 */
export type ValidHeadingLevels = (typeof ValidHeadingLevelOptions)[number];

/**
 * @param {ImageField | undefined} pageFeaturedImage The featured image for the page.
 */
export interface BasePageComponentFields {
  pageFeaturedImage?: ImageField;
}

/**
 * Sitecore page props
 * @param {InstantSearchServerState} algoliaServerState I want to stop using this soooo bad InstantSearchServerState Algolia server state
 * @param {boolean} isSearchRobot Used to trigger whether or not algollia server state should be propcessed
 * @param {ComponentPropsCollection} componentProps Collection of component props.  I don't think we currently do much with it
 * @param {DictionaryPhrases} dictionary Sitewide dictionary phrases.
 * @param {LayoutServiceData} layoutData Data returned from sitecore's Layout service for this page.
 * @param {Session} session User session data.
 * @param {string} locale Currently active locale.
 * @param {boolean} notFound Flag to indicate if the page is not found.
 * @param {string} joinCode The join code for the page.  I think we also send this back in {@link LayoutServiceContextData}?  May be value in consolidating here
 */
export interface SitecorePageProps {
  /**
   * @deprecated Run as far away from this as you can.  It's a trap!
   */
  algoliaServerState?: InstantSearchServerState;
  isSearchRobot?: boolean;
  componentProps: ComponentPropsCollection;
  dictionary: DictionaryPhrases;
  layoutData: LayoutServiceData;
  session?: Session;
  locale: string;
  notFound: boolean;
  joinCode?: string;
}

type FieldsType = {
  fields: Record<string, string | Item | Item[] | Field>;
};

export type WithFields<T, TFieldType = FieldsType['fields']> = T & {
  fields: TFieldType extends { fields: unknown } ? TFieldType['fields'] : FieldsType;
};
